import { HTTP } from '../../../http-common';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '../../../models/httpError';
import { Summary } from '../../../models/summary';
import { SmsMessage } from '@/models/SmsMessage';
const state = {
  summary: new Summary(),
  message: new httpError(),
  reportView: null,
  orderStatus: 0,
  emailResult: null,
};

//getters

const getters = {
  emailResult: (state) => state.emailResult,
  getField,
};

//Mutations
const mutations = {
  setSummary(state, summary) {
    state.summary = summary;
    state.message = new httpError();
  },
  setProgress(state, message) {
    state.message = message;
  },
  setReportView(state, orderView) {
    state.reportView = orderView;
  },
  setEmailResult(state, result) {
    state.emailResult = result;
  },
  updateField,
};

//ACTIONS
const actions = {
  resetSummary({ commit }) {
    commit('setSummary', new Summary());
  },

  sendSMS({ dispatch, commit }, sms) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await HTTP.post('Order/SendSMS', new SmsMessage(sms));
        if (response.status == 200) {
          if (response.data.map((x) => x.status == 'sent').includes(true)) {
            commit(
              'orders/setOrderStatus',
              this.state.orders.rows[0].isReporting ? 2 : 1,
              {
                root: true,
              }
            );
            dispatch(
              'setMessage',
              new httpError({
                message: 'SMS sent OK',
                httpStatus: 200,
              })
            );
            resolve(response.data.status);
          }
        }
      } catch (err) {
        dispatch(
          'setMessage',
          new httpError({
            message: 'SMS not sent :' + err.message,
            httpStatus: 500,
          })
        );
        reject();
      }
    });
  },
  sendEmail({ commit, dispatch, rootGetters }, emailOptions) {
    return new Promise((resolve, reject) => {
      emailOptions.orderID = rootGetters['orders/orderID'];
      commit('setSummary', emailOptions);

      let credCheck =
        this.state.orders.summary.reportView.isResidential &&
        !this.state.orders.rows[0].existingCustomer;

      HTTP.post(
        emailOptions.anonymous
          ? 'Order/SendFromCustomerEmail/'
          : `Docusign/SendRequest/` + credCheck,
        emailOptions
      )
        .then((data) => {
          if (data.status === 200) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'sent successfully',
                httpStatus: 200,
              })
            );

            commit(
              'orders/setOrderStatus',
              this.state.orders.rows[0].isReporting ? 2 : 1,
              {
                root: true,
              }
            );
            commit('orders/setOrderEnvelope', data.data.envelopeId, {
              root: true,
            });
            resolve(data.data);
          }
        })
        .catch((err) => {
          var error = JSON.parse(JSON.stringify(err.response));
          var message = error.data;
          if (typeof message == 'object') {
            var errorStatus = message.Status.slice(23);
            var parseErr = JSON.parse(errorStatus);
            message = parseErr.message.split('.')[1];
          }

          dispatch(
            'setMessage',
            new httpError({
              message: 'Error on sendEmail : ' + message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  getSigningUrl({ dispatch }, envelopeID) {
    return new Promise((resolve, reject) => {
      HTTP.post('Docusign/GetSigningURL', {
        envelopeID,
      })
        .then((data) => {
          if (data.status === 200) {
            window.location.href = data.data.uri;
          }
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error on Get Signing Url : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  populateSummaryPDF({ state, dispatch }, data) {
    return new Promise((resolve, reject) => {
      if (typeof data == 'undefined' && state.reportView == null) {
        reject('no data available');
        return;
      }
      let request = {
        template: {
          name: 'OrderReport',
          recipe: data == 'pdf' ? 'chrome-pdf' : 'phantom-image',
          engine: 'handlebars',
          waitForJS: true,
        },
        data: state.reportView,
      };

      HTTP.post('Report/Generate', request, { responseType: 'arraybuffer' })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: data == 'pdf' ? 'application/pdf' : 'image/png',
          });

          resolve(blob);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message:
                'Error on Connecting to Rendering PDF ' + JSON.stringify(err),
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  populateQuotePDF({ state, dispatch, rootState }, data) {
    return new Promise((resolve, reject) => {
      if (typeof data == 'undefined' && state.reportView == null) {
        reject('no data available');
        return;
      }
      let version =
        rootState.orders.flags && rootState.orders.flags.quoteToolV2;
      let request = {
        template: {
          name:
            data === 1 ? `QuoteReport${version ? 'V2' : ''}` : 'QuoteSummary',
          recipe: 'chrome-pdf',
          engine: 'handlebars',
          waitForJS: true,
        },
        data: state.reportView,
        options: {
          'Content-Disposition': 'filename=VonexQuote.pdf',
          reportName: 'VonexQuote',
        },
      };

      HTTP.post('Report/Generate', request, { responseType: 'arraybuffer' })
        .then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/pdf',
          });

          resolve(blob);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error on renderAsync : ' + err.message,
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },
  populateGrenke({ dispatch, rootState }) {
    return new Promise((resolve, reject) => {
      HTTP.post('Grenke/GrenkeFinancePDF', rootState.orders.rows[0].orderID)
        .then((data) => {
          resolve(data.data);
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error on populateGrenke : ' + err.message,
              httpStatus: 500,
            })
          );

          reject(err);
        });
    });
  },
  populateSummary({ commit, dispatch, rootGetters }, orderID) {
    if (orderID !== 0) {
      return new Promise((resolve, reject) => {
        let generate = ['Summary', 'GenerateQuote'].includes(
          rootGetters['orders/getRoute']
        );
        var response = HTTP.get(`Order/OrderReport/${orderID}/${generate}`); //, {responseType: 'document'});
        response
          .then(function (data) {
            if (data.status === 200) {
              // commit("orders/setOrder", data.data.order, {
              //   root: true,
              // });
              commit('setReportView', data.data);
              dispatch('orders/uploads/populateUploads', orderID, {
                root: true,
              });
              resolve(data.data);
            } else reject(data);
          })
          .catch(function (err) {
            dispatch(
              'setMessage',
              new httpError({
                message: 'Error on populateSummary : ' + err.message,
                httpStatus: 500,
              })
            );

            reject(err);
          });
      });
    }
  },
  verifyEmail({ commit, dispatch, rootState }, email) {
    return new Promise((resolve, reject) => {
      var url = `Auth/VerifyEmail/${email}`;

      var response = HTTP.get(url); //, {responseType: 'document'});
      response
        .then(function (data) {
          if (data.status === 200) {
            commit('setEmailResult', data.data);
            resolve(data.data);
          } else reject(data);
        })
        .catch(function (err) {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error' + err.message,
              httpStatus: 500,
            })
          );

          reject(err);
        });
    });
  },

  setMessage({ commit }, message) {
    return new Promise((resolve) => {
      commit('setProgress', message);
      if (message.httpStatus == 200)
        setTimeout(() => {
          commit('setProgress', new httpError());
          resolve();
        }, 2000);
      resolve();
    });
  },

  validateOrderView({ dispatch }, ov) {
    if (ov) {
      return new Promise((resolve, reject) => {
        var url = 'Validate/ValidateOrder';

        var response = HTTP.post(url, ov); //, {responseType: 'document'});
        response
          .then(function (data) {
            if (data.status === 200) {
              // commit("orders/setOrder", data.data.order, {
              //   root: true,
              // });
              // dispatch('orders/uploads/populateUploads', orderID, {
              //   root: true,
              // });
              resolve(data.data);
            } else reject(data);
          })
          .catch(function (err) {
            // dispatch(
            //   'setMessage',
            //   new httpError({
            //     message: 'Error' + err.message,
            //     httpStatus: 500,
            //   })
            // );

            reject(err);
          });
      });
    }
  },
  updateChannelPartnerEngagementAsync({ dispatch,commit, rootState }, engagementType) {
    return new Promise((resolve, reject) => {
      HTTP.put(
        `Order/UpdateOrderChannelPartnerEngagement/${rootState.orders.rows[0].orderID}`,
        JSON.stringify(engagementType)
      )
        .then((data) => {
          resolve(data.data.orderView);
          if (data.data) {
            commit('setReportView', data.data.orderView);
          }
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message:
                'Error on updating channel partner engagement : ' + err.message,
              httpStatus: 500,
            })
          );

          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
